<template>
  <section class="listing">
    <div class="header">
      <div class="title">Assinaturas</div>
      <!-- <button @click="$router.push('/signature/new')" class="button-new"><i class="fas fa-plus"></i><span>NOVO</span></button> -->
    </div>
    <form @submit.prevent class="form form-search">
      <input v-model="search" type="text" placeholder="Pesquisar..." />
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div class="sum-group">
          <div class="sum">
            <span>Assinaturas</span>
            <span>{{ signatures.length }}</span>
          </div>
          <div class="sum">
            <span>Profit</span>
            <span>{{ profit.length }}</span>
          </div>
          <div class="sum">
            <span>NinjaTrader</span>
            <span>{{ ninja.length }}</span>
          </div>
          <div class="sum">
            <span>NinjaBotYan</span>
            <span>{{ ninjaBotYan.length }}</span>
          </div>
          <div class="sum">
            <span>BlackArrow</span>
            <span>{{ black.length }}</span>
          </div>
          <div class="sum">
            <span>ProfitBotYan</span>
            <span>{{ profitBotYan.length }}</span>
          </div>
          <div class="sum">
            <span>BlackBotYan</span>
            <span>{{ blackBotYan.length }}</span>
          </div>
          <div class="sum">
            <span>TraddingView</span>
            <span>{{ tradding.length }}</span>
          </div>
        </div>

        <div class="list-cards">
        <div v-for="p in filtered" :key="p.id" class="list" :class="statusClass(p)">
          <div class="data">
            <div class="main-data">{{ p.user }}</div>
            <div class="detail-data">
              {{ p.product }}
              <template v-if="p.price != null">
                - R$
                {{ Number(p.price).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}
              </template>
            </div>
          </div>
          <div class="list-meta">
            <div class="main-data">{{ p.active ? 'ATIVA' : 'INATIVA' }}</div>
            <div class="detail-data">{{ p.active ? 'Próximo Vencimento ' : p.nextDate ? 'Venceu em ' : ' - '}}{{ p.nextDate }}</div>
          </div>
          <div class="actions">
            <button @click="$router.push(`/signature/${p.id}`)" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
          </div>
        </div>
        </div>
      </div>
    </transition>
    <Signature v-if="signature" :id="signature" :signatureData="signatureData" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll, remove } from '../api/signature'
import Signature from './Signature.vue'

export default {
  name: 'signatures',
  components: { Signature },
  props: ['id'],
  data () {
    return {
      loading: true,
      signature: null,
      search: '',
      signatures: [],
      signatureData: null
    }
  },
  computed: {
    profit () {
      return this.filtered.filter(x => x.profit === true)
    },
    ninja () {
      return this.filtered.filter(x => x.ninja === true)
    },
    black () {
      return this.filtered.filter(x => x.black === true)
    },
    ninjaBotYan () {
      return this.filtered.filter(x => x.ninjaBotYan === true)
    },
    profitBotYan () {
      return this.filtered.filter(x => x.profitBotYan === true)
    },
    blackBotYan () {
      return this.filtered.filter(x => x.blackBotYan === true)
    },
    tradding () {
      return this.filtered.filter(x =>
        x.black === false &&
        x.ninja === false &&
        x.profit === false &&
        x.profitBotYan === false &&
        x.blackBotYan === false &&
        x.ninjaBotYan === false
      )
    },
    filtered () {
      return this.signatures.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    async '$route' (value) {
      this.signature = value.params['id'] || null
      // Update list
      if (!value.params['id']) {
        this.getData()
      } else {
        this.signatureData = this.signatures.find(x => x.id === Number(value.params['id']))
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        this.loading = true
        this.signature = this.id || null
        this.signatures = await getAll()
        this.loading = false
      } catch (error) {
        console.error('Erro ao carregar assinaturas:', error)
        logger.error(error, this)
        this.signatures = []
        this.loading = false
      }
    },
    statusClass (item) {
      if (!item.valid) return 'list-status--inactive'
      if (item.valid === 3) return 'list-status--ok'
      if (item.valid === 2) return 'list-status--warn'
      return 'list-status--danger'
    },
    async remove (id) {
      try {
        if (this.loading) return false
        this.loading = true
        // Update user
        await remove(id)
        this.loading = false
        this.getData()
      } catch (error) {
        logger.error(error, this)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
</style>
